import React from "react";
import { Controller } from "react-hook-form";
import {
  FormControl,
  TextField,
  Autocomplete,
  IconButton,
  InputAdornment,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

const DropdownController = ({
  name,
  control,
  label,
  options,
  errors,
  disabled = false,
  required = false,
  highlight = false,
  startIcon = false,
  handleIconClick,
  onChange,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const selectedOption = options.find((opt) => opt.value === field.value);

        return (
          <FormControl fullWidth error={!!errors?.[name]}>
            <Autocomplete
              options={options}
              getOptionLabel={(option) => option.label || ""}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              value={
                selectedOption ||
                (field.value
                  ? { label: `${field.value} - Invalid`, value: field.value }
                  : null)
              }
              onChange={(event, newValue) => {
                field.onChange(newValue ? newValue.value : "")
                if (onChange) onChange(newValue ? newValue.value : "")
              }
              }
              renderOption={(props, option) => (
                <li {...props}>
                  {option.code && option.description ? (
                    <span>
                      <strong>{option.code}</strong> - {option.description}
                    </span>
                  ) : (
                    <span>{option.label}</span>
                  )}
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  variant="outlined"
                  error={!!errors?.[name]}
                  helperText={errors?.[name]?.message}
                  required={required}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: startIcon ? (
                      <InputAdornment position="start">
                        <IconButton
                          size="small"
                          onClick={handleIconClick}
                          edge="start"
                          sx={{
                            position: "absolute",
                            left: 0,
                            zIndex: 1,
                            top: "55%",
                            paddingLeft: "6px",
                            transform: "translateY(-50%)",
                          }}
                        >
                          <AddCircleOutlineIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                  sx={{
                    ...((highlight || !selectedOption) && {
                      "& .MuiInputBase-input": {
                        color: "red",
                      },
                    }),
                  }}
                />
              )}
              disabled={disabled}
            />
          </FormControl>
        );
      }}
    />
  );
};

export default DropdownController;
